import axios from "axios";
import { API } from "./newsUtils";

function authHeaders() {
  const t = localStorage.getItem("token");
  return t ? { Authorization: `Bearer ${t}` } : null;
}

// Fire-and-forget: record that the user opened a news item from a given media.
export function trackOpen(source) {
  const headers = authHeaders();
  if (!source || !headers) return;
  axios.post(`${API}/me/engagement`, { source, event: "open" }, { headers }).catch(() => {});
}

// Fire-and-forget: record time (ms) the user spent on a media.
export function trackDwell(source, ms) {
  const headers = authHeaders();
  if (!source || !headers || !ms || ms < 1500) return;
  axios.post(`${API}/me/engagement`, { source, dwell_ms: Math.round(ms) }, { headers }).catch(() => {});
}
